import Vue from 'vue';
import { GlobalAlert, AlertsState } from './types';

const state = Vue.observable<AlertsState>({
  globalAlerts: [],
});

export function getGlobalAlerts(): Array<GlobalAlert> {
  return state.globalAlerts;
}

export function addGlobalAlert(alert: GlobalAlert) {
  state.globalAlerts.push(alert);
}

export function removeGlobalAlert(alertId: number) {
  state.globalAlerts = state.globalAlerts.filter((it: GlobalAlert) => it.id !== alertId);
}
